import axios from "axios";
import Cookies from "js-cookie";

import * as SignInActions from "../../actions/SignInActions/SignInAction";
import * as allActions from "../../actions/actions.constants";
import API from "../../../network";
import { clearEmailAction } from "../../actions/emailTemplatesActions/emailTempActions";

// Helper function to fetch data from store when user click on email to join community
const getInviteFriendData = (store) => {
  const emailAction = store.getState().emailActionReducer;
  if (emailAction?.action === "InviteFriend") {
    return {
      invitedCommunityName: emailAction.tenantName?.trim() || null,
      invitedCommunityId: emailAction.tenantId
        ? Number(emailAction.tenantId)
        : null,
      emailId: emailAction.emailId
        ? decodeURIComponent(emailAction.emailId)
        : null,
    };
  }
  return null;
};

// Helper function to fetch community data when user clicks
// "Go to Skopic" from an email template
const getRedirectToCommunityData = (store) => {
  const emailAction = store.getState().emailActionReducer;

  if (emailAction?.action === "redirectToCommunity") {
    return {
      redirectCommunityName: emailAction.tenantName?.trim() || null,
      redirectCommunityId: emailAction.tenantId
        ? Number(emailAction.tenantId)
        : null,
    };
  }

  return null;
};

const getModeratorEmailAction = (store) => {
  const emailAction = store.getState().emailActionReducer;

  if (
    emailAction?.action === "userModeratorRequest" ||
    emailAction?.action === "moderatorPendingItems" ||
    emailAction?.action === "flaggedPost"
  ) {
    return emailAction;
  }

  return null;
};

const SignInservice = (store) => (next) => (action) => {
  const url = process.env.REACT_APP_SERVICES_API;
  let isNewUser = false;
  if (action.payload instanceof FormData) {
    isNewUser = action.payload.get("isNewUser");
    action.payload.delete("isNewUser");
  }
  next(action);
  // next(SignInActions.loading());
  switch (action.type) {
    case allActions.DO_SIGNIN:
      const dispatch = store.dispatch;
      dispatch(SignInActions.setAuthenticating(true));
      axios
        .request({
          url: `${url}jsonindex/security-check?source=null`,
          method: "POST",
          data: action.payload,
          withCredentials: true,
        })
        .then((res) => {
          // API.setApiHeaders(sessionId);
          next(SignInActions.receivesigninUserData(res.data));
          if (res.data.status === "AUTHORIZED") {
            if (
              res.data.userTenant !== "tenant_blocked" &&
              res.data.userTenant !== "Inactive Tenant"
            ) {
              const signStatus = res.data.status === "AUTHORIZED";
              // Cookies.set("signInStatus", signStatus, { expires: 1 });
              Cookies.set("signInStatus", signStatus);
            }
            // next(SignInActions.authUser())

            const { invitedCommunityName, invitedCommunityId } =
              getInviteFriendData(store) || {};

            // redirectToCommunity data
            const { redirectCommunityName, redirectCommunityId } =
              getRedirectToCommunityData(store) || {};

            const blockedTenants = ["tenant_blocked", "Inactive Tenant"];

            const selectedCommunityName = redirectCommunityName
              ? redirectCommunityName
              : invitedCommunityName
                ? invitedCommunityName
                : res.data.userTenant;

            const selectedCommunityId = redirectCommunityId
              ? redirectCommunityId
              : invitedCommunityId
                ? invitedCommunityId
                : res.data.userTenantId;

            const tenantName = blockedTenants.includes(res.data.userTenant)
              ? ""
              : selectedCommunityName;

            axios
              .request({
                url: `${url}jsonuser/land?redirectTenantId=${selectedCommunityId}&name=${encodeURIComponent(tenantName)}`,
                method: "POST",
                withCredentials: true,
              })
              .then((res) => {
                next(SignInActions.authUser());
                dispatch(SignInActions.setAuthenticating(false));
                const moderatorEmailAction = getModeratorEmailAction(store);
                setTimeout(async () => {
                  next(SignInActions.getLandApiResponseData(res?.data));
                }, 500);

                next(SignInActions.updateIsNewUser(isNewUser || false));
                // Clear the email action in Redux to prevent it from persisting for next login
               const emailAction = store.getState().emailActionReducer;

                if (
                  emailAction?.action !== "InviteFriend" &&
                  emailAction?.action !== "userModeratorRequest" &&
                  emailAction?.action !== "moderatorPendingItems" &&
                  emailAction?.action !== "flaggedPost" &&
                  emailAction?.action !== "followHashtag" &&
                  emailAction?.action !== "acceptPMRole" &&
                  emailAction?.action !== "rejectPMRole" &&
                  emailAction?.action !== "acceptMRole" &&
                  emailAction?.action !== "rejectMRole"
                ) {
                  dispatch(clearEmailAction());
                }

                if (
                  res.data.userCommunityStatus === "Y" ||
                  res.data.status === "OK"
                ) {
                  axios
                    .request({
                      url: `${url}jsonuser/user-data`,
                      method: "GET",
                      withCredentials: true,
                    })
                    .then((res) => {
                      next(SignInActions.loginUser(res.data));
                      if (moderatorEmailAction) {
                        window.location.href =
                          `/Moderator?tenantId=${moderatorEmailAction?.tenantId}` +
                          `&action=${moderatorEmailAction?.action}` +
                          `&tenantName=${encodeURIComponent(
                            moderatorEmailAction?.tenantName || "",
                          )}`;
                      }
                    })
                    .catch((error) => {
                      alert(
                        error.response?.data?.message ||
                          error.message || // e.g. "Network Error"
                          "Server is down",
                      );
                    });
                }
              })
              .catch((error) => {
                dispatch(SignInActions.setAuthenticating(false));

                alert(
                  error.response?.data?.message ||
                    error.message ||
                    "Server is down",
                );
              });
          } else if (res.data.status === "NewUser") {
            next(SignInActions.newUser());
          } else {
            next(SignInActions.unauthUser());
          }
          next(SignInActions.stopLoading());
          dispatch(SignInActions.setAuthenticating(false));
        })
        .catch((error) => {
          dispatch(SignInActions.setAuthenticating(false));
          next(SignInActions.stopLoading());

          alert(
            error.response?.data?.message ||
              error.message || // "Network Error"
              "Server is down",
          );
        });
      break;

    case allActions.SiGNoUT_STATUS:
      axios
        .request({
          url: `${url}jsonindex/sign-out`,
          method: "GET",
          headers: {},
          withCredentials: true,
        })
        .then((res) => {
          if (res.data.status === "SignedOut") {
            next(SignInActions.signOutData());
            Cookies.remove("signInStatus");
            localStorage.setItem('logout-event', Date.now().toString());
          }
          next(SignInActions.stopLoading());
        });
      break;
    default:
      break;
  }
};
export default SignInservice;
